import React, { useState, useEffect, useMemo } from 'react';
import { Grid, Typography } from '@mui/material';
import '../ManageComponent.css';
import {
  getApplicationStatuses,
  getUserData,
  getWfhRequest,
  updateApplicationStatus,
} from '../../../services/UserService';
import KeycloakService from '../../../services/KeycloakService';
import { useDispatch, useSelector } from 'react-redux';
import {
  RESET_DATE_RANGE,
  SHOW_NOTIFICATION,
  WFHAttribute,
} from '../../../constants';
import PaginationComponent from '../../../components/Pagination/Pagination';
import { Box } from '@mui/system';
import GenericLoader from '../../../components/Loader/GenericLoader';
import WfhStatusCardComponent from '../../../components/WfhStatusCard/WfhStatusCardComponent';
import {
  resetFilterDataState,
  setFilterConfig,
  setFilterDataState,
} from '../../../modules/filter/filterAction';
import GenericFilterDrawer from '../../../components/GenericFilter/GenericFilterDrawer';
import { useLocation } from 'react-router-dom';
import { checkFilterIconVisibility } from '../../../components/GenericFilter/FilterIconVisibilityCheck';
import { cardComponentCollapse } from '../../../modules/cardState/cardAction';
import { NO_WFH_REQUESTS } from '../ManageConstants';
import { getManagerProjects } from '../../../services/UserService';
import { getEmployeesOfManager } from '../../../services/UserService';
const ManageWfhRequestsComponent = (props) => {
  const [showError, setShowError] = useState(false);
  const uniqueList = [];
  const [wfhRequestList, setWfhRequestList] = React.useState([]);
  const [wfhTaskList, setWfhTaskList] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const [loader1, setLoader1] = React.useState(true);
  const [pageNo, setPageNo] = React.useState(0);
  const currentUserId = KeycloakService.getUserDetail();
  const dispatch = useDispatch();
  const [refreshPage, setRefreshPage] = React.useState(false);
  const [toggle, setToggle] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  const filterState = useSelector((state) => state.filterState);
  const [options, setOptions] = useState({});

  const emptyFilterData = {
    employeeName: '',
    employeeId: '',
    type: '',
    status: '',
    isUpdatedByAdmin: false,
    startDate: '',
    endDate: '',
    projectName: '',
  };

  const [pageSize, setPageSize] = useState(5);
  const [totalPage, setTotalPage] = React.useState();
  const [page, setPage] = React.useState(1);
  const [rows, setRows] = React.useState([]);
  const [empNameArray, setEmpNameArray] = React.useState([]);
  const [projectArray, setProjectArray] = useState([]);
  const uniqueIds = new Set();
  const location = useLocation();
  const xyz = new URLSearchParams(location.search).get('xyz');
  const searchString = window.atob(xyz);
  const tabType = new URLSearchParams(searchString).get('type');

  useEffect(() => {
    setOptions({ ...options, employee: empNameArray });
  }, [empNameArray]);

  const updateApplication = async (templateApplicationResponse) => {
    const updatedApplicationResponse = await updateApplicationStatus(
      templateApplicationResponse,
    );
    if (updatedApplicationResponse.isError === false) {
      setRefreshPage(!refreshPage);
    }
    dipatchNotification(
      updatedApplicationResponse.type,
      updatedApplicationResponse.message,
    );
    return updatedApplicationResponse;
  };

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const empName = async (request, id) => {
    request.empName = `${request.applicationDTO.empName}`;
  };

  const allEmpNames = async (id) => {
    const name = await getUserData(id);
    setEmpNameArray((prev) => [
      ...prev,
      { id: `${id}`, name: `${name.data.firstName} ${name.data.lastName}` },
    ]);
  };

  const getProjects = async () => {
    const projectList = await getManagerProjects(currentUserId, null, null, 0);
    if (projectList?.status === 200) {
      setProjectArray((prevProjects) => [...projectList.data.content]);
      setOptions({ ...options, project: projectList.data.content });
    } else {
      setProjectArray((prevProjects) => []);
      setOptions({ ...options, project: [] });
    }
    setLoader(false);
  };

  const getAppliersList = async (userId) => {
    const applierList = await getEmployeesOfManager(currentUserId, '');
    if (Array.isArray(applierList.data)) {
      applierList.data.forEach((item) => {
        const employeeId = item.employeeId;
        const employeeName = item.employeeName;
        if (!uniqueIds.has(employeeId)) {
          uniqueIds.add(employeeId);
          setEmpNameArray((prev) => [
            ...prev,
            { id: `${employeeId}`, name: `${employeeName}` },
          ]);
        }
      });
    }
  };

  const getApproversList = async (request, applicationId) => {
    const approversList = await getApplicationStatuses(applicationId);
    request.approverList = approversList?.data?.data;
  };

  const getUserName = async (id) => {
    const empName = await getUserData(id);
    const employeeName = `${empName.data.firstName} ${empName.data.lastName}`;
    dispatch(
      setFilterDataState({ ...filterState, employeeName: employeeName }),
    );
  };

  const getWfhRequests = async () => {
    const wfhRequests = await getWfhRequest(
      currentUserId,
      filterState,
      filterState.isUpdatedByAdmin,
      pageSize,
      pageNo,
    );
    if (wfhRequests?.isError === false) {
      setTotalPage(wfhRequests.data.data.totalPages);
      await Promise.all(
        wfhRequests.data.data.content.map(async (request) => {
          await empName(request, request.applicationDTO.employeeId);
          await getApproversList(request, request.applicationDTO.id);
        }),
      );
      setWfhRequestList(wfhRequests.data.data.content);
      setLoader1(false);
      setLoader(false);
    }
    if (wfhRequests.status !== 200) {
      dipatchNotification(wfhRequests.type, wfhRequests.message);
    }
  };

  const pageChange = (event, value) => {
    setPageNo(value - 1);
    setPage(value);
    setLoader(true);
    setRefreshPage(!refreshPage);
    setLoader(true);
  };

  const handlePageSizeChange = (event) => {
    const newPageSize = event.target.value;
    setPageSize(newPageSize);
    pageChange(null, 1);
    setRefreshPage(!refreshPage);
    setLoader(true);
  };

  const filterConfiguration = {
    inputField: [
      [
        ['status', 'WFH Status'],
        [
          ['APPROVED', 'Approved'],
          ['PENDING', 'Pending'],
          ['REJECTED', 'Rejected'],
          ['TASK_APPROVED', 'Task Approved'],
          ['TASK_PENDING', 'Task Pending'],
        ],
      ],
    ],
    checkField: [['isUpdatedByAdmin', 'Updated by HR']],
    autoComplete: [['Search Employee', 'employee']],
    dropdownField: [
      // ['Search Employee', 'employee', 'name', 'id'],
      ['Search Project', 'project', 'projectName', 'projectId'],
    ],
  };

  const resetThings = () => {
    for (let arrayOfArrays of filterConfiguration.dropdownField) {
      setOptions({ ...options, [arrayOfArrays[1]]: [] });
    }
    dispatch(setFilterConfig(filterConfiguration));
    if (tabType !== 'WFH') {
      dispatch(resetFilterDataState());
      dispatch({
        type: RESET_DATE_RANGE,
      });
      dispatch(cardComponentCollapse());
    }
  };

  useEffect(() => {
    resetThings();
    getAppliersList();
    getProjects();
    setResetFilter(true);
  }, []);

  const temp = useMemo(() => {
    pageChange(null, 1);
    if (filterState?.employeeId && filterState?.employeeName === undefined) {
      getUserName(filterState.employeeId);
    }
  }, [filterState]);

  useEffect(() => {
    if (resetFilter) getWfhRequests();
  }, [refreshPage, resetFilter]);

  return (
    <>
      <>
        {loader || loader1 ? (
          <div style={{ height: '70vh', overflow: 'hidden' }}>
            <GenericLoader
              rectAttributes={WFHAttribute}
              showError={showError}
              setShowError={setShowError}
            />
          </div>
        ) : (
          <>
            {checkFilterIconVisibility(
              filterState,
              emptyFilterData,
              wfhRequestList,
            ) && <GenericFilterDrawer options={options} />}
            <Box
              sx={{
                overflow: 'hidden',
              }}
            >
              {wfhRequestList.length != 0 ? (
                wfhRequestList.map((request, index) => {
                  return (
                    <WfhStatusCardComponent
                      key={request.id}
                      wfh={request}
                      wfhStatus={request.status}
                      isManagerOrAdmin={true}
                      updateApplication={updateApplication}
                      refresh={refreshPage}
                      setRefresh={setRefreshPage}
                    />
                  );
                })
              ) : (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '70vh',
                  }}
                >
                  <div>
                    <Typography>{NO_WFH_REQUESTS}</Typography>
                  </div>
                </div>
              )}
            </Box>
            {wfhRequestList.length ? (
              <Box className="page-holder">
                <PaginationComponent
                  count={totalPage}
                  page={page}
                  pageChange={pageChange}
                  pageSize={pageSize}
                  handlePageSizeChange={handlePageSizeChange}
                />
              </Box>
            ) : (
              <></>
            )}
            {/* </div> */}
          </>
        )}
      </>
    </>
  );
};

export default ManageWfhRequestsComponent;
